<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6"> Update Minutes </h6>
<div class="card" >
    <div class="card-body" *ngIf='displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />

<div class="row" *ngIf='displayState.gridDiv'>
  <div class="col-md-3 offset-1">
    <p-table [value]="hearingDateList" [scrollable]="true" scrollHeight="555px"  >
      <ng-template pTemplate="header">
          <tr style="font-size:small;">
              <th style="width: 5%;" >&nbsp;</th>
              <th style="width: 10%;" >
                  Hearing Date/Time - Board #
              </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-hearing>
          <tr style="font-size: small;">
              <td style="width: 5%;">
                  <button class='btn btn-sm btn-link' (click)="onSelectHearing(hearing)">Select</button>
              </td>
              <td style="width: 10%;">{{hearing.hearingDate | date:"MM/dd/yyyy"}} {{hearing.hearingTime}} - Board: {{hearing.boardNumber}}</td>
          </tr>
      </ng-template>
    </p-table>
  </div>
  <div *ngIf='displayState.caseListDiv' class="col-md-3">
    <p-table [value]="schedCaseList" [scrollable]="true" scrollHeight="520px"  >
        <ng-template pTemplate="caption">
            <strong>Cases on: </strong> {{myHearing.hearingDate | date: 'MM/dd/yyyy'}} {{myHearing.hearingTime}} - Board: {{myHearing.boardNumber}}
        </ng-template>

      <ng-template pTemplate="header">
          <tr style="font-size:small;">
              <th style="width: 5%;" >&nbsp;</th>
              <th style="width: 7%;" >
                  Case #
              </th>
              <th style="width: 15%;" >
                  Applicant
            </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-case>
          <tr style="font-size: small;">
              <td style="width: 5%;">
                  <button class='btn btn-sm btn-link' (click)="onSelectCase(case)">Select</button>
              </td>
              <td style="width: 7%;">{{case.caseNum}}</td>
              <td style="width: 15%;">{{case.applicantName}}</td>
          </tr>
      </ng-template>
    </p-table>
    <br />
    <br />

    <div class="form-row" *ngIf="displayState.caseListDiv && !displayState.headerFooterTextDiv">
        <div class="col-md-9 col-md-offset-3">
            <button class="btn btn-sm btn-info" (click)="headerFooterText()">Text for Header and Footer</button>
            <!--
            <button type="submit" class="btn btn-sm">Print 1 Order</button>
            <button type="submit" class="btn btn-sm">Print Labels</button>
            -->
        </div>
    </div>
  </div>

  <div *ngIf='displayState.editMinutesDiv' class="card bg-light col-md-4">
    <div class="card-body">
        <div class="form-row" *ngIf='myCase'>
            <label class="col-md-10 offset-1 prd-header">Minutes for: {{myCase.caseNum}} - {{myCase.applicantName}}</label>
        </div>
        <div class="form-row">
            <textarea rows="10" class="form-control col-md-10 offset-1 prd-required" id="minutesText" [(ngModel)]='myMinutes.minutesNote'></textarea>
        </div>
        <hr />
        <div class="form-row">
            <!-- Buttons -->
            <button class="btn btn-success offset-1 col-md-2" (click)="saveMinutes()"
                    [disabled] = "displayState.saveDisabled" >Save</button>
            <button class="btn btn-warning offset-1 col-md-2" (click)="cancelEntry()">Cancel</button>
            <button class="btn btn-danger offset-3 col-md-2" title="DELETE minutes for this date/case"
                    [disabled] = "displayState.deleteDisabled" (click)="deleteMinutes()">Delete</button>
        </div>

    </div>
  </div>

</div>
<br/>
<div class="form-row" *ngIf="displayState.headerFooterTextDiv">
    <div class="card-body">
        <div class="form-row" style="margin-bottom: 10px;">
            <div class="col offset-4">
                <strong>Header/Footer for Hearing: </strong> {{myHearing.hearingDate | date: 'MM/dd/yyyy'}}
            </div>
        </div>

        <!-- Header -->
        <div class="form-row">
            <label class="col-md-1 offset-3">Header Text</label>
            <textarea rows="3" maxlength="1000" class="form-control col-md-5" id="minutesHeader"
                      title="Enter Header text - max 1000 characters"
                      [(ngModel)]='myHearing.minutesHeader'></textarea>
        </div>
        <br />
        <!-- Footer -->
        <div class="form-row">
            <label class="col-md-1 offset-3">Footer Text</label>
            <textarea rows="3" maxlength="1000" class="form-control col-md-5" id="minutesFooter"
                      title="Enter Footer text - max 1000 characters"
                      [(ngModel)]='myHearing.minutesFooter'></textarea>
        </div>

        <!-- Buttons -->
        <br />
        <div class="form-row">
            <div class="offset-4 col-sm-8">
                <button class="btn btn-warning col-md-1" (click)="headerFooterTextCancel()">Cancel</button>
                <button class="btn btn-success offset-1 col-md-1" (click)="savePrePostMinutesText()">Save</button>
            </div>
        </div>
    </div>
</div>
